import { cn } from "@/lib/utils";

const SectionTag = ({ className = "", text = "", icon = null }: { className?: string; text?: string; icon?: React.ReactNode }) => {
  if (!text) return null;
  return (
    <span
      className={cn(
        "flex items-center font-medium text-rebolt-800 tracking-wide border border-rebolt-500/20 bg-rebolt-100 rounded-full px-5 py-1.5 w-fit",
        className
      )}
    >
      {icon}
      {text}
    </span>
  );
};

export default SectionTag;
